
<script>
  import { Pie, mixins } from 'vue-chartjs'
  // import chartjsPluginAnnotation from "chartjs-plugin-annotation";
  // const { reactiveProp } = mixins

  export default {
    name: "BarChart",
    extends: Pie,
    mixins: [mixins.reactiveProp],
    props: {
      chartData: {
        type: Object,
        default: null
      },
      options: {
        type: Object,
        default: null
      },
      reRender: {
        type: Number,
        default: 0
      }
    },
    mounted () {
      this.renderChart(this.chartData, this.options)
    },
    watch: {
      reRender() {
        const self = this
        setTimeout(() => { 
          if (self.$data._chart) { 
            self.$data._chart.destroy(); 
          }
          self.renderChart(self.chartData, self.options)
        }, 1000)
      }
    }
  }
</script>

<style>
</style>